// extracted by mini-css-extract-plugin
var _1 = "FacebookButton-module__button___eY0Fb";
var _2 = "FacebookButton-module__children___baKyE";
export { _1 as "button", _2 as "children" }
